export class SystemState {
  fpsTracker: boolean = false;
  positionTracker: boolean = false;
}
